import numeral from "numeral";

export default function (value, format = "0,0") {
  if (typeof value !== "number") {
    return value;
  }
  return numeral(value).format(format);
}
